/*
 * Copyright © 2020-2022 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: caoran
 * @LastEditTime: 2024-08-28 13:55:22
 */
/* eslint-disable */
import axios from 'axios'
import { Toast } from 'vant'
import { encodeHttpParams, decodeHttpResult } from '../todayUtils'
import getUA from '../getUA'
import { ensureGlobalApiOrigin } from './clusterContext'

const instance = axios.create({
  timeout: 30000
})

const isEnvProduction = process.env.NODE_ENV === 'production'
const isEnvStaging = process.env.NODE_ENV === 'staging'
// 本地开发环境（BUILD_ENV=local），navigator.onLine 在 localhost 下可能不可靠
const isEnvLocal = process.env.BUILD_ENV === 'local'

export const requestInterceptor = instance.interceptors.request.use(
  async (config) => {
    if (!navigator.onLine && !isEnvLocal) {
      // Toast('网络异常')

      return Promise.reject(new Error('网络异常'))
    }

    // App webview 内按原生返回的 cluster 解析；外链按 URL ?cluster= 参数解析
    // （都在未取到时回退默认集群 sg，兼容旧版本 App/链接）。
    const baseURL = config.baseURL || (await ensureGlobalApiOrigin())

    let params = config.data

    // 生产环境：App 内加密；预发环境：App 内时加密（依赖 JS bridge）
    // skipEncryption: true 可跳过加解密（用于不走加解密的新接口）
    const shouldEncrypt =
      !config.skipEncryption &&
      ((isEnvProduction && config.data && getUA().isTodayCamera) ||
        (isEnvStaging && config.data && getUA().isTodayCamera))
    if (shouldEncrypt) {
      params = await encodeHttpParams(config.data)
    }

    return {
      ...config,
      baseURL,
      data: params
    }
  },
  (error) => {
    return Promise.reject(error)
  }
)

export const responseInterceptor = instance.interceptors.response.use(
  async (response) => {
    let result = response.data
    let isBase64Decode = false
    // 单个接口配置是否需要base64解密，优先级最大
    if (response.config.isBase64DecodeHttpResult !== undefined) {
      isBase64Decode = response.config.isBase64DecodeHttpResult
    } else {
      // 单个接口没有配置时，根据整个实例是否配置为准
      isBase64Decode = !!instance.isBase64DecodeHttpResult
    }

    // 生产环境：App 内解密；预发环境：App 内 时解密（依赖 JS bridge）
    const shouldDecrypt =
      !response.config.skipEncryption &&
      ((isEnvProduction && getUA().isTodayCamera) ||
        (isEnvStaging && getUA().isTodayCamera))
    if (shouldDecrypt) {
      result = await decodeHttpResult(response.data, isBase64Decode)
    }
    return {
      ...response,
      data: result
    }
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default instance
